export enum CarrierAssignmentPermissions {
  CarrierAssigment = 'carrier-assignment',
  VoCarrierAssigment = 'vo-carrier-assignment',
  MboCarrierAssigment = 'mbo-carrier-assignment',
  AssignmentPreparation = 'assignment-preparation',
  AssignmentEvaluation = 'assignment-evaluation',
}
